import AdminHttpService from "admin/common/adminHttpService";
import ReturnsNullOn404 from "common/http/returnsNullOn404";

class ExternalComponentService extends AdminHttpService {

    @ReturnsNullOn404()
    async getBidStyle(merchantId: string): Promise<string> {
        var result = await this.getClient(merchantId).get<string>("/settings/v1/files/styles/bid-component.preview.css");

        return result.data;
    }
    
    async setBidStyle(merchantId: string, content: string, isPreview: boolean): Promise<any> {
        var result = await this.getClient().put(
            `/settings/v1/merchants/${merchantId}/bid-style`, {
                content: content,
                isPreview: isPreview
            });

        return result.data;
    }
}

const externalComponentService = new ExternalComponentService();

export default externalComponentService;